import IconButton from '@material-ui/core/IconButton';
import CheckIcon from '@material-ui/icons/Check';
import EditIcon from '@material-ui/icons/Edit';

import css from '../nibTable.module.sass';

const Edit = ({ onClick = () => {}, status, customEditIcon, ...props }) => {
  return (
    <div className={css.edit}>
      <IconButton onClick={onClick}>
        {status ? <CheckIcon /> : customEditIcon ? customEditIcon : <EditIcon />}
      </IconButton>
    </div>
  );
};

export default Edit;
